module.exports = __webpack_public_path__ + "media/speech.49405d28.mp3";